export const FIELD_TYPES = [
  { value: 'text', label: 'Текст' },
  { value: 'select', label: 'Список' },
  { value: 'phone', label: 'Телефон' },
  { value: 'email', label: 'Почта' },
  { value: 'url', label: 'Ссылка' },
  { value: 'forum', label: 'Форум' }
];

export const VALIDATION_PATTERNS = {
  name: /^[а-яА-ЯёЁa-zA-Z\s-]{2,50}$/,
  organization: /^[а-яА-ЯёЁa-zA-Z0-9\s.,«»"'()№/\-]{2,300}$/,
  position: /^[а-яА-ЯёЁa-zA-Z0-9\s.,«»"'()/\-]{2,150}$/,
  phone: /^\+7 \(\d{3}\) \d{3}-\d{2}-\d{2}$/,
  email: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  url: /^https?:\/\/\S+$/i
};

export const createFieldKey = () => `field_${Date.now().toString(36)}${Math.random().toString(36).slice(2, 6)}`;

export const createEmptyFormField = (type = 'text') => ({
  clientKey: createFieldKey(),
  key: createFieldKey(),
  label: type === 'select' ? 'Новый список' : 'Новое поле',
  type,
  required: true,
  locked: false,
  options: type === 'select' ? ['Вариант 1'] : [],
  placeholder: type === 'select' ? 'Выберите значение' : ''
});

export const normalizeFormFieldsFromApi = (fields = []) =>
  fields.map((field, index) => ({
    clientKey: field.key || `field-${index}`,
    key: field.key,
    label: field.label || '',
    type: field.type || 'text',
    required: field.required !== false,
    locked: Boolean(field.locked) || field.type === 'forum',
    options: Array.isArray(field.options) ? field.options : [],
    placeholder: field.placeholder || ''
  }));

export const serializeFormFieldsForApi = (fields = []) =>
  fields.map((field) => ({
    key: field.key,
    label: field.label || '',
    type: field.type,
    required: Boolean(field.required),
    locked: Boolean(field.locked),
    options: field.type === 'select' ? (field.options || []).map((option) => String(option).trim()).filter(Boolean) : [],
    placeholder: field.placeholder || ''
  }));

export const getFormFieldsSnapshot = (fields = []) =>
  JSON.stringify(serializeFormFieldsForApi(fields));

export const getFieldTypeLabel = (type) =>
  FIELD_TYPES.find((item) => item.value === type)?.label || 'Текст';

export const getRegistrationFieldValue = (registration, field) => {
  if (!registration || !field) return '';

  if (registration.fieldValues && Object.prototype.hasOwnProperty.call(registration.fieldValues, field.key)) {
    return registration.fieldValues[field.key] ?? '';
  }

  if (field.type === 'forum') {
    return registration.programTitle || registration.programSectionId || '';
  }

  if (registration.extraFields && Object.prototype.hasOwnProperty.call(registration.extraFields, field.key)) {
    return registration.extraFields[field.key] ?? '';
  }

  return registration[field.key] ?? '';
};

export const getFieldValidationRules = (field) => {
  const rules = {};

  if (field.required) {
    rules.required = field.type === 'select' || field.type === 'forum'
      ? `Выберите ${field.label.toLowerCase()}`
      : 'Это поле обязательно';
  }

  if (field.type === 'email') {
    rules.pattern = {
      value: VALIDATION_PATTERNS.email,
      message: 'Введите корректный email'
    };
  }

  if (field.type === 'phone') {
    rules.pattern = {
      value: VALIDATION_PATTERNS.phone,
      message: 'Некорректный номер телефона'
    };
  }

  if (field.type === 'url') {
    rules.pattern = {
      value: VALIDATION_PATTERNS.url,
      message: 'Вставьте ссылку, начинающуюся с http:// или https://'
    };
  }

  if (field.type === 'text') {
    if (field.key === 'lastName' || field.key === 'firstName' || field.key === 'middleName') {
      rules.pattern = {
        value: VALIDATION_PATTERNS.name,
        message: `Некорректное ${field.label.toLowerCase()}`
      };
    }
    if (field.key === 'organization') {
      rules.pattern = {
        value: VALIDATION_PATTERNS.organization,
        message: 'Некорректное название организации'
      };
    }
    if (field.key === 'position') {
      rules.pattern = {
        value: VALIDATION_PATTERNS.position,
        message: 'Некорректная должность'
      };
    }
  }

  return rules;
};
